import { createNanoEvents } from 'nanoevents';
import {
    ContentStatusManager,
    IContentStatusEvents,
} from '@tencent/slide-sdk-model/src/manager/content-status-manager';
export * from '@tencent/slide-sdk-model/src/manager/content-status-manager';


/**
 * 文档状态管理模块，兼容2.0和3.0。
 *
 * 目前文档有6种状态，各个状态所影响的内容如下所示：
 * ```md
 * ┌──────────────┬────────────────────────────────────────────────────┐
 * │              │  报错    退出    能否导出图片     演示    保存  进编辑态 │
 * ├──────────────┼────────────────────────────────────────────────────┤
 * │ loadingHead  │   N      Y          N           N       N      N   │
 * ├──────────────┼────────────────────────────────────────────────────┤
 * │ loadingChunk │   N      Y          N           N       N      N   │
 * ├──────────────┼────────────────────────────────────────────────────┤
 * │ sync         │   N      Y          Y           Y       Y      Y   │
 * ├──────────────┼────────────────────────────────────────────────────┤
 * │ modified     │   N    弹提示        Y           Y       Y      Y   │
 * ├──────────────┼────────────────────────────────────────────────────┤
 * │ syncing      │   N      Y          Y           Y     保存中    Y   │
 * ├──────────────┼────────────────────────────────────────────────────┤
 * │ corrupted    │   Y      N          N           N       N      N   │
 * └──────────────┴────────────────────────────────────────────────────┘
 * ```
 * @see https://git.woa.com/SNG-RDCenter-Beijing/slide-base-sdk/blob/master/packages/slide-sdk-model/src/manager/README.md
 */


export function createContentStatusManager() {
    return new ContentStatusManager(createNanoEvents<IContentStatusEvents>());
}
